import React from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import moment from 'moment';
import authentication from 'utils/authentication';
import convert from 'utils/convert';
import messages from 'messages';
import { toast } from 'react-toastify';

const useAuth = () => {
  if(authentication.getSessionStorages('dst') && authentication.getSessionStorages('mn') && authentication.getSessionStorages('mcl')){
    const dataAuth = authentication.decryptData('dst');
    const decodedToken = authentication.getDecodedJwttoken(dataAuth.token);
    const status = dataAuth.status;
    const exp = decodedToken.exp;
    const timeToken = moment(exp, 'X');
    const timeNow = moment();

    if(status && exp > 0 && timeToken > timeNow){
      return true;
    }else{
      console.log('m');
      toast.error(messages.error.expiredToken);
      authentication.deleteAllSession();
      return false;
    }
  }else{
    console.log('ra');
    return false;
  }
};

const PrivateRoute = () => {
  const location = useLocation();
  const auth = useAuth();

  if(auth){
    const menu = authentication.getSessionStorages('mn');
    const defaultMenu = {
      code: 'MNU_000',
      inactiveFlag: false,
      index: 0,
      level: 0,
      name: '',
      parentCode: '',
      parentName: ''
    };
    menu.push(defaultMenu);

    let splitPathname = location.pathname.split('/');
    let str_pathname = splitPathname[1];
    if(menu.map(x => convert.spasiToSnakeCase(x.name)).includes(str_pathname)){
      return <Outlet />;
    }else{
      if(str_pathname === ''){
        return <Navigate 
          replace 
          to={{
            pathname: '/'
          }}
        />;
      }else{
        return <Navigate 
          replace
          to={{
            pathname: '/404'
          }}
        />;
      }
    }
  }else{
    return <Navigate 
      replace 
      to={{
        pathname: '/login',
        search: `?redirect=${location.pathname}${location.search}`,
      }}
    />;
  }
};


export default PrivateRoute;
